import { RouterStateSnapshot } from '@angular/router';
import { Location } from '@angular/common';

export function pathnameFromRouterState(state: RouterStateSnapshot): string {
	const url = urlFrom(state.url);
	return url.pathname;
}

export function urlFrom(link: string) {
	if (!link) return;

	const url = link.includes('://') ? new URL(link) : new URL(Location.joinWithSlash(location.origin, link));

	return url;
}

export function queryParamsObjectFrom(link: string): Record<string, string | number> {
	const url = urlFrom(link);

	if (!url) return;

	const queryParams = {};

	url.searchParams.forEach((value, name) => {
		queryParams[name] = value;
	});

	return queryParams;
}

export function toAngularRouterParts(link: string) {
	const url = urlFrom(link);

	if (!url) return;

	const pathname = url.pathname;
	const queryParams = {};

	url.searchParams.forEach((value, name) => {
		queryParams[name] = value;
	});

	return {
		queryParams,
		pathname,
	};
}
